import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)
import { CachedApi } from './CachedApi'

export class WidgetApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
	}

	/**
	 * Get all widgets
	 *
	 * @param {mixed} key
	 *
	 * @return {Promise}
	 */
	all (params) {

		let c = new CachedApi();

		return c.get(this.url + '/widgets', params);
	}

}
